import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectStrategyEvaluationData,
  selectStrategyEvaluationStatus,
  fetchStrategyEvaluationDataWithFilters,
} from '../../features/strategyEvaluation/strategyEvaluationSlice';
import { selectPriceData } from '../../features/price/priceSlice';
import CostComparisonBar from './CostComparisonBar';
import SessionSummaryTable from './SessionSummaryTable';
import ProfileOverlayChart from './ProfileOverlayChart';

export default function StrategyEvaluationPanel() {
  const dispatch = useDispatch();
  const evalData = useSelector(selectStrategyEvaluationData);
  const evalStatus = useSelector(selectStrategyEvaluationStatus);
  const priceAPIData = useSelector(selectPriceData);

  const [selectedSession, setSelectedSession] = useState(null);

  useEffect(() => {
    if (['idle', 'succeeded'].includes(evalStatus)) {
      dispatch(fetchStrategyEvaluationDataWithFilters({}));
    }
  }, []);

  const evaluations = evalData?.results || [];
  const latestEval = evaluations[0] || null;
  const priceSignal = priceAPIData?.results?.[0]?.summer_price_signal || [];

  if (evalStatus === 'loading') {
    return (
      <Typography variant="body2" color="text.secondary">
        Loading strategy evaluations…
      </Typography>
    );
  }

  if (!evaluations.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        No strategy evaluations available yet.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      <CostComparisonBar evaluations={evaluations} />
      <SessionSummaryTable
        evaluations={evaluations}
        onSelectSession={(ev) => setSelectedSession(ev)}
      />
      {selectedSession && (
        <ProfileOverlayChart evaluation={selectedSession} priceSignal={priceSignal} />
      )}
    </Stack>
  );
}
